import { render, staticRenderFns } from "./TabsDashboardSeats.vue?vue&type=template&id=76a2b687&"
import script from "./TabsDashboardSeats.vue?vue&type=script&lang=js&"
export * from "./TabsDashboardSeats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports